import FittingEvaluationItemList from "../FittingEvaluationItemList/fittingEvaluationItemList";
import { useEffect, useState } from "react";
import { appAxiosInstance } from "../../../api";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { PaginationControl } from "react-bootstrap-pagination-control";
import s from './fittingEvaluationList.module.css';
import { IFittingEvaluation, IFittingEvaluationRequestParams, IFittingEvaluationResponse } from '../types';
import { Loader } from "../../../components/Loader/loader";
import { Pagination } from "../../../components/Pagination/Pagination";

export default function FittingEvaluationList() {
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [allItems, setAllItems] = useState(0);
    const [dateBegin, setDateBegin] = useState('');
    const [dateEnd, setDateEnd] = useState('');
    const [fittingEvaluation, setFittingEvaluation] = useState<IFittingEvaluation[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [filteredByDate, setFilteredByDate] = useState<IFittingEvaluation[]>([]);
    const [filteredByDateWithPagination, setFilteredByDateWithPagination] = useState<IFittingEvaluation[]>([]);
    
    const getFittingEvaluation = async () => {

        try {
            setIsLoading(true);
            const fittingEvaluationResponse = await appAxiosInstance.get<IFittingEvaluation[]>('logs/getFittingWithFeedback', { });
            setFittingEvaluation(fittingEvaluationResponse.data);
            console.log(fittingEvaluation)

        } catch (error) {
            toast.error(`Ошибка при получении оценок переодеваний`);
            setFittingEvaluation([]);
        } finally {
            setIsLoading(false);
        }
    };

    const filterEvaluationWithPagination = () => {
        const startIndex = (currentPage - 1)*itemsPerPage;
        const endIndex = currentPage*itemsPerPage;
        setFilteredByDateWithPagination(filteredByDate.slice(startIndex, endIndex));
    }
    
    const paginate = (pageNumbers: number) => {
        setCurrentPage(pageNumbers);
        filterEvaluationWithPagination();
    }

    const filterEvaluation = () => {
        const dateBeginLocal = dateBegin === '' ? "2020-05-22T06:44:00.263" : dateBegin;
        const dateEndLocal = dateEnd === '' ? "3000-05-22T06:44:00.263" : dateEnd;
    
    const localList = fittingEvaluation.filter(evaluation => {
        const evalDate = new Date(evaluation.sendFeedbackDate);
        const startDate = new Date(dateBeginLocal);
        const endDate = new Date(dateEndLocal);
        
        return evalDate >= startDate && evalDate <= endDate;
        });
    
    setFilteredByDate(localList);
    setAllItems(localList.length);
    }

    const find = () => {
        filterEvaluation();
        setCurrentPage(1);
    }

    const cleanForm = () => {
        setDateBegin('');
        setDateEnd('');
        filterEvaluation();
        setCurrentPage(1);
    }

    useEffect(() => {
        getFittingEvaluation();
    }, []);

    useEffect(()=> {
        filterEvaluationWithPagination();
    }, [filteredByDate]);

    useEffect (()=> {
        filterEvaluation();
    }, [fittingEvaluation, currentPage])

    return (

        <div>
            <div className={s.filterBlock}>
                <div className={s.dateBlock}>
                    <div className={s.headerName}>Дата начала</div>
                    <input
                        value={dateBegin}
                        type="date"
                        onChange={e => setDateBegin(e.target.value)}
                        placeholder="Введите дату начала для фильтрации"
                        className={s.filterClothesFormUp}
                    />
                </div>
                <div className={s.dateBlock}>
                    <div className={s.headerName}>Дата окончания</div>
                    <input
                        value={dateEnd}
                        type="date"
                        onChange={e => setDateEnd(e.target.value)}
                        placeholder="Введите дату начала для фильтрации"
                        className={s.filterClothesFormUp}
                    />
                </div>
                <Button type="button" className={s.searchFormButton} onClick={find}>Поиск</Button>
                <Button type="button" className={s.searchFormButton} onClick={cleanForm}>Сбросить фильтр</Button>
            </div>

            {isLoading ? (
                <div className={s.loadingContainer}>
                    <Loader/>
                </div>
                ) : (
                <div>
                    {filteredByDateWithPagination && filteredByDateWithPagination.length > 0 ? (
                    filteredByDateWithPagination.map((evaluation, index) => (
                        <FittingEvaluationItemList key={`fitting-${index}`} evaluation={evaluation} />
                    ))
                    ) : (
                    <div className={s.emptyState}>
                        <h3 className={s.emptyStateTitle}>Оценки не найдены</h3>
                    </div>
                    )}
                </div>
            )}

            <Pagination
                page={currentPage}
                between={2}
                total={allItems}
                limit={itemsPerPage}
                changePage={(page) => {
                    paginate(page)
                }}
                ellipsis={1}
            />
        </div>
    );
}